import React, { Fragment } from "react";
import { Button } from "../../Button";
import { SearchSize, } from "../../types/ArticleHeader";
import { Row } from "react-bootstrap";
import { ArticleHeaderContext } from "../../hooks/articleHeaderContext";
import { Title } from "../../Title";
import { FormContextProvider } from "../../Form";
import parseChildren from "../../utils/parseChildren";
import { Search } from "../../Search";
import { Tab } from "../../Tab";
export function FutureArticleHeader(_a) {
    var title = _a.title, children = _a.children, pageInfo = _a.pageInfo, _b = _a.titleLevel, titleLevel = _b === void 0 ? "h2" : _b, extra = _a.extra, create = _a.create, filters = _a.filters, search = _a.search, loading = _a.loading, _c = _a.uniqueId, uniqueId = _c === void 0 ? 1 : _c, id = _a.id, tabs = _a.tabs, dataId = _a.dataId, dataTestId = _a.dataTestId;
    var numberOfFilters = 0;
    var filterChildren = parseChildren(children);
    if (filters) {
        numberOfFilters = filterChildren.length;
    }
    return (React.createElement(ArticleHeaderContext.Provider, { value: {
            loading: loading,
            numberOfFilters: numberOfFilters,
        } },
        React.createElement("div", { className: "article-header article-header--portal", id: id, "data-testid": dataTestId, "data-id": dataId },
            (title || extra || create) && (React.createElement("div", { className: "article-header--heading" },
                title && (React.createElement(Title, { titleLevel: titleLevel },
                    React.createElement(Fragment, null,
                        title,
                        " ",
                        pageInfo && "(".concat(pageInfo.totalRecords, ")")))),
                tabs && (React.createElement(Tab.Menu, { items: tabs, type: "bar", dataHook: "article-header--tabs" })),
                extra && (React.createElement("div", { className: "article-header-heading--extra" },
                    extra,
                    create && (React.createElement(Button, { type: "primary", label: create.label, onClick: create.onClick, disabled: create.disabled, id: create.id })))))),
            (search || filters) && (React.createElement(AffectBar, { filters: filters, search: search, uniqueId: id || uniqueId, title: title }, children)))));
}
function AffectBar(_a) {
    var search = _a.search, uniqueId = _a.uniqueId, children = _a.children, filters = _a.filters, title = _a.title;
    return (React.createElement(Row, null,
        React.createElement("div", { className: "affectBar--container affectBar--".concat(!search ? "noSearch" : ""), "aria-label": "Search and filtering ".concat(title ? "for ".concat(title) : "") },
            React.createElement("div", { className: "affectBar--row" },
                search && (React.createElement(Search, { initialValue: search.initialValue, label: search.label, onChange: search.onChange, uniqueId: uniqueId, debounceTime: search.debounceTime, iconPosition: "left", componentSize: SearchSize.LG })),
                search && filters && (React.createElement("div", { className: "affectBar--filters-divider" })),
                filters && (React.createElement(Filters, { values: filters.values, onSubmit: filters.onSubmit }, children))))));
}
function Filters(_a) {
    var values = _a.values, onSubmit = _a.onSubmit, children = _a.children;
    return (React.createElement(FormContextProvider, { values: values, onSubmit: onSubmit }, children));
}
